import { useEffect, useState } from "react";

export function useKonamiCode() {
  const konamiSequence = [
    "ArrowUp", "ArrowUp",
    "ArrowDown", "ArrowDown",
    "ArrowLeft", "ArrowRight",
    "ArrowLeft", "ArrowRight",
    "KeyB", "KeyA"
  ];

  const [konamiActive, setKonamiActive] = useState(false);
  const [position, setPosition] = useState(0);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (konamiActive) return; // já ativou → não precisa monitorar mais

      if (e.code === konamiSequence[position]) {
        const nextPosition = position + 1;

        if (nextPosition === konamiSequence.length) {
          setKonamiActive(true);   // ativa
          setPosition(0);          // opcional: reseta sequência
        } else {
          setPosition(nextPosition);
        }
      } else {
        // errou: verifica se tecla atual é a primeira do código
        setPosition(e.code === konamiSequence[0] ? 1 : 0);
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [position, konamiActive]);

  return konamiActive;
}
